module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Ack#fm-1"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction#fm-2"
    }
  }, [_vm._v("Introduction: The Value of Skepticism in the Christian Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#ch-1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Breadth of the Miraculous in the Bible")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Jesus the Miracle Worker")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Jesus and the Natural World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Jesus and the Demonic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("If Jesus Did That Then, Why Not Now?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Virginal Laptop")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Learning to Love the Weird Parts of the Bible")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Reading#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Recommended Readings")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27bbe38a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0